module.exports = __webpack_public_path__ + "img/top-bg-index.d5e5811c.png";